import { Box } from '@mui/material';
import { ArrowUpward as ArrowUpwardIcon, ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material';
import { tableTokens } from './table-tokens.js';

export type SortDirection = 'asc' | 'desc' | null;

export function TableSortIndicator({ direction }: { direction: SortDirection }) {
  if (!direction) return null;
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        color: 'text.secondary',
        fontSize: tableTokens.typography.headerFontSize,
      }}
    >
      {direction === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
    </Box>
  );
}
